/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { useTranslation } from 'react-i18next';

import { bem } from '../../../../core/design/bem';

const css = bem('MessagesPopup__List');
const translationPrefix = 'messages.popup.list';

type MessagesListProps = {
  messages: Record<string, any>[];
};

export const MessagesList = (props: MessagesListProps): JSX.Element => {
  const { messages = [] } = props;
  const { t } = useTranslation();
  if (messages.length === 0) {
    return (
      <div className={css()}>
        <span className={css('no-messages')}>{t(`${translationPrefix}.no-messages`)}</span>
      </div>
    );
  }

  return <div className={css()}>TODO After</div>;
};
